export default[
    {
        path: '/oqhdaq6xD7ltoqhdaq6xD7lt',
        children:[
            {
                path:'IIXsZR16Mk09IIXsZR16Mk09',
                name: 'attendance_analysis',
                meta: {
                    title: 'Attendance Analysis',
                    authRequired: true,
                    acc: null
                },
                component: ()=> import('@/views/attendance/analysis/index.vue')
            },
            {
                path:'IIXsZR16Mk09IIXsZR16Mk09',
                name: 'attendance',
                meta: {
                    title: 'Attendance',
                    authRequired: true,
                    acc: null
                },
                component: ()=> import('@/views/attendance/index.vue')
            },
        ]
    }
]